import { AreaGateLogAdministrationModule } from './../../components/area-gate-log-administration/area-gate-log-administration.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AreaGateLogAdministrationWidgetComponent } from './area-gate-log-administration/area-gate-log-administration.component';
import { WidgetDefinition, WidgetRegistryService } from '@sdbn/common';



@NgModule({
  declarations: [
    AreaGateLogAdministrationWidgetComponent
  ],
  imports: [
    CommonModule,
    AreaGateLogAdministrationModule

  ]
})
export class AreaGateLogAdministrationWidgetModule {



  constructor(
    private widgetRegistryService: WidgetRegistryService
  ) {
    widgetRegistryService.registerWidget(new WidgetDefinition({ key: 'areaGateLogAdministration', name: 'AreaGateLogAdministration', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: AreaGateLogAdministrationWidgetComponent, editorComponent: null, autoreload: false }));
  }



}
